const getters = {
    token: state => state.user.token,
    userId: (state) => state.user ? state.user.userId : null,
    userInfo: (state) => state.user ? state.user.userInfo : null,
    cart: state => state.cart.list,
}
export default getters
